__turbopack_context__.v({
  "EmployeeSelectForm": "chatter-reports-module__dUHTeG__EmployeeSelectForm",
  "Employees": "chatter-reports-module__dUHTeG__Employees",
  "chatterReportsContent": "chatter-reports-module__dUHTeG__chatterReportsContent",
  "chatterReportsOverview": "chatter-reports-module__dUHTeG__chatterReportsOverview",
  "reportsPerformance": "chatter-reports-module__dUHTeG__reportsPerformance",
  "tabContent": "chatter-reports-module__dUHTeG__tabContent",
  "tabs": "chatter-reports-module__dUHTeG__tabs",
});
